const tabConfig = {
    tabs: [
        {
            id: '0',
            radio: 'radio-1',
            intent: 'PromtData',
            label: 'tabData',
            icon: 'database',
            accessKey: 'DataAccess',
            dropdownItems: [
                { id: 0, name: "Orders database" },
                { id: 1, name: "CRM database" }
            ],
            visible: false
        },
        {
            id: '1',
            radio: 'radio-2',
            intent: 'PromtEmbeddings',
            label: 'tabDocuments',
            icon: 'description',
            accessKey: 'DocumentsAccess',
            dropdownItems: [],
            visible: true
        },
        {
            id: '2',
            radio: 'radio-3',
            intent: 'PromptGpt',
            label: 'tabChat',
            icon: 'contact_support',
            accessKey: 'ChatAccess',
            dropdownItems: [
                { id: 0, name: "GPT-5-mini" },
                { id: 1, name: "GPT-5" }
            ],
            visible: true
        }
    ]
};

export default tabConfig;